import React, {ReactNode} from 'react';
import cx from 'classnames';
import {Icon, ToolbarIcons} from '@priority-software/priority-style-react';
import {emailDialogID} from '../../../../features/EmailEditor/testIDs';
import {ModernTooltip} from '../../../Common/Tooltip/ModernTooltip';
import {createDataTestId} from '../../../../utils/dataTestId';

type TIconWithPopover = {content?: ReactNode; disabled?: boolean} & (
    | {type: 'children'; children: ReactNode}
    | {
          type: 'icon';
          icon?: ToolbarIcons;
          onClick: (e) => void;
          componentClasses?: string;
      }
);

export const IconWithPopover = (props: TIconWithPopover): JSX.Element | null => {
    const {disabled} = props;

    let Component: JSX.Element | null = null;

    if (props.type === 'children') {
        Component = <>{props.children}</>; // wrap to ensure JSX
    } else {
        const {icon, onClick, componentClasses} = props;

        Component = (
            <Icon
                {...{
                    ...createDataTestId(`toolbar-${icon}-icon`, true),
                    onClick: disabled ? undefined : onClick,
                    icon,
                    componentClasses: cx('priority-editor__toolbar-item', {
                        disabled: disabled,
                        [componentClasses || '']: componentClasses
                    }),
                    style: {
                        userSelect: 'none',
                        cursor: disabled ? 'not-allowed' : 'pointer'
                    },
                    iconColor: disabled ? 'secondary-300' : 'primary-700'
                }}
            />
        );
    }

    if (!props.content) {
        return Component;
    }

    return (
        <ModernTooltip
            {...createDataTestId(`email-toolbar-tooltip`, true)}
            tooltip={props.content}
            maxWidth={400}
            position="top"
            tooltipOffset={8}
            portalId={emailDialogID}
        >
            {Component}
        </ModernTooltip>
    );
};
